import React from 'react';
import css from '../styles/area-real-estate.css';

const { Component } = React;

class AreaRealEstate extends Component {
  render() {
    return (
      <div className="areas-grid-item areas-grid-item--real-estate">
        <div class="areas-grid-item__wrapper">
          <div class="areas-area__hero">
          </div>
          <div class="areas-area__hero-text" data-aos="zoom-in">
            <h3>Real Estate Transactions</h3>
            <p>I can assist you with your commercial real estate transaction – purchase and sale, refinance, or loan modification.  I can also advise and assist with your lease negotiation, modification or extension, SNDA (Subordination, Non-disturbance, and Attornment agreement), sublease, or assignment.</p>
          </div>
        </div>
      </div>
    );
  }
}

export { AreaRealEstate };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Areas/components/area-real-estate.js